import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import { Button, Checkbox, CheckboxGroup, Collapsible, Dropdown, Form, Input, Modal, Radio, RadioGroup, Toast, Upload } from '@douyinfe/semi-ui';
import { Image } from '@douyinfe/semi-ui';
import useRequest from '@/utils/useRequest';
import { Router, useRouter } from 'next/router';
import { IndexContext } from "@/stores";
import classNames from 'classnames';
import { debounce, toArray } from 'lodash';
import useJSEncrypt from '@/utils/useJsEncrypt';
import Head from 'next/head';
import { PRODDOMAIN } from '@/utils';

interface IProps {
}

const Apply: NextPage<IProps> = ({ }) => {
  const router = useRouter() as any
  const { encryptText } = useJSEncrypt()
  // const [prodCate, setProdCate] = useState([])
  const [country, setCountry] = useState([])
  const [region, setRegion] = useState([])
  const [filed, setFiled] = useState([])
  const [companyTypes, setCompanyTypes] = useState([])
  const [cate, setCate] = useState([])
  const [selectCate, setSelectCate] = useState<number[]>([])
  const [selectSubCate, setSelectSubCate] = useState<number[]>([])
  const [checkMap, setCheckMap] = useState({})
  const [city, setCity] = useState([])
  const [applyid, setApplyId] = useState()
  const [visible, setVisible] = useState(false)
  const [isLogo, setIsLogo] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const formRef = useRef<any>()
  const areaRef = useRef<any>()
  const checkbox = useRef<any>()
  const { setIsHeadFoot, setLang } = useContext(IndexContext);
  const request = useRequest()

  const btnClick = useCallback(() => {
    const { main_category, logo, belong_name, booth_width, booth_height, ...params } = formRef.current.getFormState().values
    if (!checkbox.current) {
      Toast.error({
        content: '请先同意《数据保护条例-展商》',
      })
      return
    }

    if (main_category?.id != 39 && !checkNodes(selectCate, selectSubCate, true)) {
      Toast.error({
        content: '具体产品类别需要选到子分类',
      })
      return
    }
    formRef.current.validate().then(async () => {
      if (booth_height * booth_width < 18) {
        Toast.error({
          content: '光地展位18㎡起租',
        })
        return
      }
      // if (isLogo && !logo) {
      //   Toast.error({
      //     content: '请上传公司Logo',
      //   })
      //   return
      // }
      if (main_category?.id != 39 && ![...selectCate, ...selectSubCate].length) {
        Toast.error({
          content: '请至少选择一个具体产品类别',
        })
        return
      }
      const { data } = await request.post('/api/booth/apply', {
        ...params,
        logo,
        booth_width, booth_height,
        main_category: main_category.id,
        sub_category: main_category.id != 39 ? [...selectCate, ...selectSubCate].join(',') : '',
        belong_name,
        industry_background: belong_name
      })

      if (data?.code == 1) {
        Toast.success({
          content: "提交成功",
        })
        formRef.current.reset()
        setSelectCate([])
        setSelectSubCate([])
        setApplyId(data.data.apply_id)
        // window.scrollTo(0, 0)
        return;
      } else {
        Toast.error({
          content: data.msg,
        })
      }

    }).catch((err: any) => {
      Toast.error({
        content: '请填写完整信息',
        duration: 3,
      })
    })

  }, [selectCate, selectSubCate, isLogo])

  const download = useCallback(async () => {
    if (!applyid) {
      Toast.error({
        content: '请先提交申请',
        duration: 3,
      })
      return
    }
    try {
      setLoading(true);
      const response = await request.get(`/api/booth/proceedings/${applyid}`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', '会刊.pdf');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error('下载失败:', error);
      alert('文件下载失败，请检查权限或网络。');
    } finally {
      setLoading(false);
    }
  }, [applyid])

  const uploadLogo = useCallback(async (files: any) => {
    console.log(files[0].size > 1048576);

    if (files[0].size > 1048576) {
      Toast.error({
        content: '图片过大',
        duration: 3,
      })
      return
    }
    const key = await encryptText(`smart:${new Date().getTime()}`)
    const { data } = await request('/api/upload/token', {
      params: {
        key
      }
    })
    if (data?.data?.token) {
      const { data: imgData } = await request.post('/api/booth/upload_logo', {
        token: data?.data?.token,
        file: files[0]
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      formRef.current.setValue('logo', imgData?.data?.url)
    }

  }, [formRef.current])

  const transOption = useCallback((arr: any = []) => {
    if (!arr.length) return []
    return arr?.map((item: any) => {
      return {
        ...item,
        childlist: transOption(item.childlist),
        key: item.id,
        value: item.id,
        label: item.name_cn || item.name
      }
    })
  }, [])

  const countSelectedLeafNodes = useCallback((selectedIds: number[]) => {
    let leafCount = 0;
    const traverse = (nodes: any) => {
      for (const node of nodes) {
        if (selectedIds.includes(node.value)) {
          if (node.childlist.length === 0) {
            leafCount++;
          } else {
            traverse(node.childlist);
          }
        }
      }
    }
    traverse(cate);

    return leafCount;

  }, [cate])

  const checkNodes = useCallback((parent: any, children: any, isCheck = false) => {
    let arr = parent
    let flag = true

    cate.forEach((item: any) => {
      if (
        parent.includes(item.id)
        && item.childlist.length
        && !item.childlist.some((child: any) => children.includes(child.id))
      ) {
        arr = arr.filter((child: any) => child !== item.id)
        flag = false
      }
    })

    !isCheck && setSelectCate(arr)
    return flag
  }, [cate])

  const findDifference = (arr1: number[], arr2: number[]): number => {
    // 使用 Set 来方便地进行数组差异的计算
    const set2 = new Set(arr2) as any;
    for (const num of arr1) {
      if (!set2.has(num)) {
        return num; // 找到第一个不在arr2中的元素并返回
      }
    }
    return 0
  }

  const clearNodes = useCallback((id: number) => {
    const item = cate.find((item: any) => item.id == id) as any
    const set = new Set(item.childlist?.map((item: any) => item.id))
    const arr = selectSubCate.filter((num: number) => {

      return !set.has(num)
    })
    setSelectSubCate(arr)
  }, [cate, selectSubCate])

  const getCity = useCallback(async (pid: string) => {
    const { data } = await request.get(`/api/region/list`, {
      params: {
        pid
      }
    })
    const arr = transOption(toArray(data?.data?.list))

    setCity(arr)
  }, [])

  const getFiled = useCallback((filed: string) => {
    return formRef.current.getValue(filed)
  }, [formRef.current])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/api/region/data`)
    const { data: info } = await request.get(`/api/setting/info`)
    setFiled(info?.data?.category)
    setCompanyTypes(transOption(Array.from({
      ...info?.data?.company_types,
      length: Object.keys(info?.data?.company_types).length + 1
    }).slice(1) as any))
    setCountry(transOption(data?.data?.country))
    setRegion(transOption(data?.data?.province))

  }, [])

  useEffect(() => {
    setIsHeadFoot(false)
    getData()
    return () => {
      setIsHeadFoot(true)
    }
  }, [])


  return (
    <div>
      <div className={styles.container}>
        <Head>
          <title>预订展位 | 2025亚洲有机产业展览会</title>
          <meta name="keywords" content="展位预订，亚洲有机产业展览会，2025上海有机展，参展申请，有机产品展示" />
          <meta name="description" content="立即预订2025亚洲有机产业展览会的展位，展示您的有机产品，拓展商业网络，获取最新行业资讯。" />
        </Head>
        <div className={styles.content}>
          <div className={styles.header}>
            <p><span style={{ color: '#f79700' }}>有机</span><br />可持续生活之美</p>
            <div className={styles.info}>
              <h1>亚洲有机产业展览会</h1>
              <p>
                <span className={styles.time}>2025.09.03-05</span>
                <span className={styles.site}>上海新国际博览中心</span>
              </p>
            </div>
            <div className={styles.btns}>
              <a href="https://www.organic-festa.com/">
                <div className={styles.backBtn} style={{ backgroundColor: 'transparent' }}>返回首页</div>
              </a>
              {/* <a href="/">
                <div className={styles.backBtn}>已是展商，返回登录</div>
              </a> */}
            </div>
          </div>
          <div className={styles.form}>
            <div className={styles.title}>
              <h2>展位申请<span>标记*为必填</span></h2>
              <Dropdown
                style={{ width: '148px' }}
                render={
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setLang('cn')}>中文</Dropdown.Item>
                    <Dropdown.Item onClick={() => setLang('en')}>English</Dropdown.Item>
                  </Dropdown.Menu>
                }
              >
                <div className={styles.langBtn}>
                  语言：
                </div>
              </Dropdown>
            </div>
            <Form
              getFormApi={(formApi: any) => formRef.current = formApi}
              labelPosition="left"
              labelWidth="145px"
              labelAlign="right"
            >
              {
                (({ formState, values, formApi }) => (
                  <div>
                    <h3><span>*</span>展位类型</h3>
                    <div className={classNames([styles.type, 'type'])}>
                      <Form.RadioGroup
                        field="booth_type"
                        label={(<span></span>)}
                        direction='vertical'
                        rules={[
                          { required: true, message: '必填项, 不能为空' },
                        ]}
                        onChange={() => {
                          formRef.current.reset(['booth_area1', 'booth_area'])
                        }}
                      >
                        <Form.Radio value="1">
                          <div className={styles.radioRight}>
                            <div className={styles.label}>
                              <p>光地展位<span>/㎡</span></p>
                              <span>18㎡起租</span>
                            </div>
                            <Form.InputNumber
                              field="booth_width"
                              hideButtons
                              min={1}
                              disabled={getFiled('booth_type') != '1'}
                              placeholder='请输入长'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '1', message: '必填项' },
                              ]}
                            />
                            <span>*</span>
                            <Form.InputNumber
                              field="booth_height"
                              hideButtons
                              min={1}
                              disabled={getFiled('booth_type') != '1'}
                              placeholder='请输入宽'
                              label={(<span></span>)}
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '1', message: '必填项' },
                              ]}
                            />
                          </div>
                        </Form.Radio>
                        <Form.Radio value="2" className='standard'>
                          <div className={styles.radioRight}>
                            <div className={classNames([styles.label, styles.standard])}>
                              <p>标准展位<span>/㎡</span></p>
                            </div>
                            <Form.Select
                              field={getFiled('booth_type') == '2' ? 'booth_area' : 'booth_area1'}
                              label={(<span></span>)}
                              disabled={getFiled('booth_type') != '2'}
                              placeholder='请选择'
                              trigger='blur'
                              rules={[
                                { required: getFiled('booth_type') == '2', message: '必填项' },
                              ]}
                            >
                              <Form.Select.Option value="9">9</Form.Select.Option>
                              <Form.Select.Option value="12">12</Form.Select.Option>
                              <Form.Select.Option value="18">18</Form.Select.Option>
                            </Form.Select>
                          </div>
                        </Form.Radio>
                      </Form.RadioGroup>
                    </div>
                    <Form.TextArea
                      className='textarea'
                      field="booth_remark"
                      placeholder='请输入'
                      label={(<span className={classNames([styles.textAreaLabel])}>特殊搭建要求</span>)}
                      trigger='blur'
                    />
                    <h3 className={styles.formTitle}>展商信息</h3>
                    <div className={styles.exhInfo}>
                      <div className={styles.twoCol}>
                        <Form.Select
                          field="main_category"
                          label={(<span className={styles.required}>主要展示领域</span>)}
                          style={{ maxWidth: '383px' }}
                          placeholder='请选择'
                          trigger='blur'
                          onChangeWithObject
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                          optionList={transOption(filed)}
                          onChange={(option: any) => {
                            setCate(option.childlist)
                            setSelectCate([])
                            setSelectSubCate([])
                          }}
                        >
                          {/* {
                          filed.map((item: any) => (
                            <Form.Select.Option value={item.id}>{item.name_cn}</Form.Select.Option>
                          ))
                        } */}
                        </Form.Select>
                      </div>

                      <Form.Slot label={(
                        <span className={styles.required}>具体产品类别</span>
                      )}>
                        <div className={classNames(['slot', styles.proTypes])}>
                          {
                            getFiled('main_category')?.id == 39 ?
                              <Form.Input
                                field="other_category"
                                placeholder='请输入具体产品类别'
                                trigger='blur'
                                rules={[
                                  { required: true, message: '必填项' },
                                ]}
                              />
                              : <>
                                <p>（方便您的潜在客户快速找到您，每个领域最多勾选3项）</p>
                                <CheckboxGroup
                                  onChange={(value: any) => {
                                    const all = [...value, ...selectSubCate]
                                    const count = countSelectedLeafNodes(all)
                                    if (value.length < selectCate.length) {
                                      clearNodes(findDifference(selectCate, value))
                                      setSelectCate(value)
                                      return
                                    }
                                    if (count > 3 || (count === 3 && all.length > 4))
                                      return
                                    setSelectCate(value)
                                  }}
                                  value={selectCate}
                                >
                                  {
                                    cate.map((item: any) => (
                                      <>
                                        <Checkbox
                                          style={{ fontWeight: 'bold' }}
                                          value={item.value}
                                        >
                                          {item.label}
                                        </Checkbox>
                                        {
                                          !!item.childlist.length &&
                                          selectCate
                                            ?.includes(item.value) && (
                                            <CheckboxGroup
                                              value={selectSubCate}
                                              style={{ marginLeft: '30px', gap: '20px 60px' }}
                                              // field={`cate_child_${item.value}`}
                                              onChange={(value: any) => {
                                                const count = countSelectedLeafNodes([...selectCate, ...value])
                                                if (count > 3)
                                                  return
                                                count === 3 && checkNodes(selectCate, value)
                                                setSelectSubCate(value)

                                              }}
                                              options={item.childlist}
                                              direction='horizontal'
                                            />
                                          )
                                        }
                                      </>
                                    ))
                                  }
                                </CheckboxGroup>
                              </>
                          }

                        </div>
                      </Form.Slot>
                      <Form.TextArea
                        className='textarea'
                        field="product_cn"
                        placeholder='请输入'
                        label={(<span className={classNames([styles.textAreaLabel])}>主要展品信息<br className='minHidden' />（中）</span>)}
                      />
                      <Form.TextArea
                        className='textarea'
                        field="product_en"
                        placeholder='请输入'
                        label={(<span className={classNames([styles.textAreaLabel])}>主要展品信息<br className='minHidden' />（英）</span>)}
                      />
                      <div style={{ margin: '10px 0 0' }}>
                        <Form.RadioGroup
                          options={[{ label: '是', value: 1 }, { label: '否', value: 0 }]}
                          style={{ gap: '40px' }}
                          field="is_belong"
                          labelWidth='auto'
                          label={(<span className={styles.required}>是否为认证机构/政府组织/行业协会</span>)}
                          direction="horizontal"
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                      </div>
                      <div className={styles.company}>
                          <Form.RadioGroup
                            options={companyTypes.map((item: any) => {
                              return {
                                label: item.title_cn,
                                value: item.id
                              }
                            })}
                            style={{ gap: '20px 40px', flexWrap: 'wrap' }}
                            field="company_type"
                            label={(<span>公司类型</span>)}
                            direction="horizontal"
                          />
                      </div>
                      {getFiled('company_type') == 7 && <Form.Input
                        field="company_type_other"
                        label={(<span></span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                        ]}
                      />}
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="company_cn"
                          placeholder='请输入公司名称'
                          label={(<span className={styles.required}>公司名称(中文)</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="company_en"
                          placeholder='请输入公司英文名称'
                          label={(<span className={styles.required}>公司名称(英文)</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                      </div>
                      <Form.Slot label={(<span>公司地址</span>)}>
                        <div className={classNames([styles.address, 'slot'])}>
                          <Form.Select
                            field="country_id"
                            label={(<span>国家</span>)}
                            placeholder='请选择国家'
                            onSelect={(value: any, option: any) => {
                              formRef.current.setValue('phone_code', '+' + option.code)
                              setVisible(value == 256)
                            }}
                            optionList={country}
                          >
                          </Form.Select>
                          {(getFiled('country_id') == 256 && <>
                            <Form.Select
                              field="province_id"
                              label={(<></>)}
                              placeholder='省份'
                              optionList={region}
                              onSelect={(value: any, option: any) => {
                                getCity(value)
                                formRef.current.reset(['city_id'])
                              }}
                            />
                            <Form.Select
                              field="city_id"
                              label={(<></>)}
                              placeholder='市区'
                              optionList={city}
                              onSelect={(value: any, option: any) => {
                                formRef.current.setValue('phone_zone', option.area_code)
                              }}
                            />
                          </>)}
                        </div>
                      </Form.Slot>
                      <Form.Input
                        field="address"
                        placeholder='请输入详细地址'
                        label={(<></>)}
                      />
                      <div className={styles.twoCol}>
                        {/* <Form.InputNumber
                          field="phone"
                          hideButtons
                          placeholder='请输入公司电话'
                          label={(<span className={styles.required}>联系电话</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        /> */}
                        <Form.Input
                          field="website"
                          placeholder='如无请填写无'
                          label={(<span>公司网站</span>)}
                        />
                      </div>
                      {/* <Form.Input
                        field="com_email"
                        placeholder='请输入公司邮箱'
                        label={(<span className={styles.required}>公司邮箱</span>)}
                        trigger='blur'
                        rules={[
                          { required: true, message: '必填项' },
                          {
                            validator: (rule, value) => {
                              const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              return emailRegex.test(value);
                            }, message: '请输入有效邮箱'
                          }
                        ]}
                        style={{ maxWidth: '383px' }}
                      /> */}
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="contact"
                          placeholder='请输入联系人姓名'
                          label={(<span className={styles.required}>联系人</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                        <Form.Input
                          field="position"
                          placeholder='请输入职位'
                          label={(<span className={styles.required}>职位</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        {/* <Form.InputNumber
                          field="mobile"
                          hideButtons
                          placeholder='请输入手机号码'
                          label={(<span className={styles.required}>手机号码</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                            {
                              validator: (rule, value) => {
                                const regex = /^1[3-9]\d{9}$/;
                                return regex.test(`${value}`);
                              }, message: '请输入有效手机号码'
                            }
                          ]}
                        /> */}
                        <Form.Input
                          field="phone"
                          placeholder='请输入联系电话'
                          label={(<span className={styles.required}>联系电话</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                          ]}
                        />
                        <Form.Input
                          field="email"
                          placeholder='请输入邮箱'
                          label={(<span className={styles.required}>邮箱</span>)}
                          trigger='blur'
                          rules={[
                            { required: true, message: '必填项' },
                            {
                              validator: (rule, value) => {
                                const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                return emailRegex.test(`${value}`);
                              }, message: '请输入有效邮箱'
                            }
                          ]}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        <Form.Slot label={(
                          <span>联合参展商数量(如有)</span>
                        )}>
                          <div className='slot'>
                            <Form.InputNumber
                              field="union_count"
                              hideButtons
                              placeholder='请输入人数'
                              min={1}
                              precision={0}
                            />
                          </div>
                        </Form.Slot>
                      </div>
                      {(getFiled('union_count') > 0) && <Form.Slot label={(
                        <span>联合参展商名称及联系方式</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('union_company') && <div className={styles.unionPlace} onClick={() => {
                            areaRef.current.focus()
                          }}>
                            <p>如：  展商姓名1</p>
                            <p>1234545678911</p>
                            <p>如：  展商姓名2</p>
                            <p>1234545678911</p>
                          </div>}
                          <Form.TextArea
                            ref={areaRef}
                            className='textarea'
                            field="union_company"
                            style={{ height: '160px', backgroundColor: 'transparent' }}
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>}

                      <Form.Slot style={{ margin: '20px 0 0' }} label={(
                        <span
                          // className={classNames({ [styles.required]: isLogo })}
                          style={{}}
                        >企业Logo</span>
                      )}>
                        <Upload
                          action={''}
                          limit={1}
                          uploadTrigger='custom'
                          onFileChange={uploadLogo}
                          // onChange={(props) => setLogo(props.fileList[0].url)}
                          renderFileItem={() => null}
                        // draggable={true}
                        >
                          <div className={styles.upload}>
                            <div className={styles.uploadBox}>
                              {
                                !!getFiled('logo')
                                  ? <Image className={styles.image} src={getFiled('logo')} preview={false} />
                                  : <div className={styles.btn}>点击上传logo</div>
                              }

                            </div>
                            <p>Logo大小：≤ 2MB，尺寸：240*160像素，格式：JPG/PNG，分辨率：300dpi及以下</p>
                          </div>
                        </Upload>
                      </Form.Slot>
                      {/* <Form.Slot style={{ margin: '15px 0' }}
                        label={(<span>企业无Logo</span>)}>
                        <Checkbox style={{ marginTop: '10px' }} onChange={(e) => setIsLogo(!isLogo)}>是</Checkbox>
                      </Form.Slot> */}
                      <Form.Slot label={(
                        <span>企业简介<br className='minHidden' />（中）</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('content_cn') && <div className={styles.intro}>
                            <p>网站展示，字数不限</p>
                          </div>}
                          <Form.TextArea
                            className='textarea'
                            field="content_cn"
                            style={{ backgroundColor: 'transparent' }}
                            placeholder='请输入企业简介（中文）'
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>
                      <Form.Slot label={(
                        <span>企业简介<br className='minHidden' />（英）</span>
                      )}>
                        <div className='slot'>
                          {!getFiled('content_en') && <div className={styles.intro}>
                            <p>网站展示，字数不限</p>
                          </div>}
                          <Form.TextArea
                            className='textarea'
                            field="content_en"
                            style={{ backgroundColor: 'transparent' }}
                            placeholder='请输入企业简介（英文）'
                            label={(<></>)}
                          />
                        </div>
                      </Form.Slot>
                      <Form.Slot className='belong' label={(
                        <span
                          className={styles.required}
                        >协会及行业背景</span>
                      )}>
                        <div className='slot'>
                          <Form.Input
                            field="belong_name"
                            placeholder='请输入协会及行业背景（如无可填无）'
                            label={(<></>)}
                            trigger='blur'
                            rules={[
                              { required: true, message: '必填项' },
                            ]}
                          />
                          <p style={{ color: '#bbb', fontSize: '14px', lineHeight: '24px' }}>所属认证机构/协会 （或推荐单位）</p>
                        </div>
                      </Form.Slot>
                    </div>
                    <h3 className={styles.formTitle}>财务信息</h3>
                    <div className={styles.finInfo}>
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="invoice_title"
                          placeholder='请输入发票抬头'
                          label={(<span>发票抬头</span>)}
                        />
                        <Form.Input
                          field="tax_code"
                          placeholder='请输入税号'
                          label={(<span>税号</span>)}
                        />
                      </div>
                      <div className={styles.twoCol}>
                        <Form.Input
                          field="bank_name"
                          placeholder='请输入开户银行'
                          label={(<span>开户银行</span>)}
                        />
                        <Form.Input
                          field="bank_account"
                          placeholder='请输入银行账号'
                          label={(<span>银行账号</span>)}
                        />
                      </div>
                    </div>
                  </div>
                ))
              }
            </Form>

            <div className={styles.footer}>
              <div className={styles.allow}>
                <Checkbox className='is-check' onChange={(e) => checkbox.current = e.target.checked}>
                  <p style={{ color: 'white' }}>我已阅读并同意</p>
                </Checkbox>
                <span onClick={() => setIsOpen(!isOpen)}>《数据保护条例-展商》</span>
              </div>
              <Collapsible isOpen={isOpen}>
                <p className={styles.allowText}>
                  本人在此授权杜塞尔多夫展览（上海）有限公司
                  （"MDS"）收集、处理和使用本人提供的信息，用
                  于内部客户管理。本人知晓：我所提供的信息将会
                  被传输至MDS的海外集团公司（如：德国杜塞尔多夫
                  展览集团）以及外部服务提供商做进一步处理/使用。
                  此外，本人同意MDS及其集团公司基于我向MDS提供的
                  信息，通过邮递信件、电子邮件、短信/彩信以及电
                  话等方式向我发送商业讯息（包括但不限于通知、问
                  卷调查和展览提醒）。</p>
              </Collapsible>
              <div className={styles.btns}>
                <div className={styles.subBtn} onClick={debounce(() => btnClick(), 500)}>提交</div>
                <Button
                  className={styles.download}
                  onClick={debounce(() => download(), 500)}
                  loading={loading}
                >下载会刊</Button>
              </div>

            </div>
          </div>
        </div>
        <p>Copyright © 2025 杜塞尔多夫展览有限（上海）公司  版权所有 <a href="https://beian.miit.gov.cn/" target='_blank'>沪ICP备13014242号-28</a></p>
      </div >
    </div >
  );
};

export default Apply;
